<template>
  <div class="topic_supply">
    <div class="typeNav">
        <van-tabs v-model="typeActive" @change="typeChange">
           <van-tab title="Supply" :name="'Supply'"></van-tab>
           <van-tab title="Purchase" :name="'Purchase'" ></van-tab>
        </van-tabs>
      </div>
    <div class="supply_list" v-if="(dataList && dataList.length)||loading">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="It's the end~"
        @load="loadMore"
      >
        <div
          class="supplu_item"
          v-for="(item, index) in dataList"
          :key="index"
          @click="LinkToSupply(item.id)"
        >
          <div class="item_info" v-if="item.publisher">
            <img
              :src="item.publisher.avatarUrl"
              v-load="'oPicXS'"
              alt
              v-if="item.publisher.avatarUrl"
            />
             <span class="flag-icon my-flag-icon" v-else-if="item.member" :class="'flag-icon-'+item.member.flagStyle"></span>
            <img src="@/assets/img/empty.png"  v-else />
            <div class="top_info" v-if="item.member&&item.member.inMember&&item.member.inMember.companyUsers" >
                <div class="info1">
                  <span class="name" v-if="item.member.inMember.companyUsers.linkNameEn">{{item.member.inMember.companyUsers.linkNameEn||''}}</span>
                  <span class="job" v-if="item.member.jobTitleEn">{{item.member.jobTitleEn}}</span>
                </div>
                <div class="comp_name" v-if="item.member.inMember.companyUsers.company">{{item.member.inMember.companyUsers.company.nameEn}}</div>
              </div>
            <div class="top_info" v-else>
              <div class="info1">
                <span class="name" v-if="item.publisher.publisherName||item.publisher.publisherNameEn">{{
                  item.publisher.publisherNameEn||item.publisher.publisherName
                }}</span>
                <span class="job" v-if="item.publisher.jobTitle">{{
                  item.publisher.jobTitle
                }}</span>
              </div>
              <div class="comp_name" v-if="item.publisher.compNameEn">
                {{ item.publisher.compNameEn}}
              </div>
            </div>
            <div class="right_info" v-if="item.memberId != userInfo.id">
              <div
                class="like_btn"
                @click.stop="likeClick(item.id)"
                v-if="!item.isFollow"
              >
                Follow
              </div>
              <div
                class="like_btn cancel_btn"
                @click.stop="cancelLike(item.id)"
                v-else
              >
                Unfollow
              </div>
            </div>
          </div>
          <div class="item_top">
            <span v-if="item.type">#{{ item.type }}#</span>{{item.productName}}
          </div>
          <div class="item_con van-multi-ellipsis--l2" v-html="item.content"></div>
          <div class="item_img" v-if="item.imgUrls.length">
            <img
              v-for="(imgurl, ind) in item.imgUrls"
              :key="ind"
              :src="imgurl"
              v-load="'oPic'"
              alt
            />
          </div>
          <div class="item_img video" v-else-if="item.videos">
              <img  v-for="(video,ind) in item.videos" :key="ind" :src="video.cover"  >
              <div class="play_mask">
                <i class="iconfont icon-zhibo"></i>
              </div>
            </div>
          <div class="item_bottom">
            <div class="item_count">
              <i class="iconfont icon-guankan2"></i>
              <span>{{ item.viewCount }}</span>
              <i class="iconfont icon-xunpan"></i>
              <span>{{ item.commentCount }}</span>
            </div>
            <p>{{ item.createAt }}</p>
          </div>
        </div>
        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </van-list>
    </div>
    <div class="no-msg" v-else>No data！</div>
    <div class="et">
      <div class="item item_gx" @click="toolHandle('fb')">Create one</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import gql from "graphql-tag";
export default {
  name: "supply",
  data() {
    return {
      loading: false, //展商加载状态
      finished: false, //加载是否完成状态
      dataList: [], //供需列表
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      totalPages: 0,
      querySupplyDemand: {},
      isFollow: false,
      typeActive:'Supply',
      isLoading:false,
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
    }),
    SupplyGql() {
      if(this.userInfo){
      return gql`
        query querySupplyDemand($query: QueryInput!) {
          querySupplyDemand(query: $query) {
            hasNextPage
            pageIndex
            totalCount
            items {
              createAt
              auditState
              commentCount
              isFollow(memberId: "${this.userInfo.id}")
              type
              content
              exhibitionId
              followCount
              id
              imgUrls
              videos
              likeCount
              productName
              memberId
              publisher {
                avatarUrl
                compName
                compNameEn
                publisherNameEn
                publishId
                jobTitle
              
              }
              member{
                flagStyle
                jobTitleEn
                inMember(exhibitionId:"${this.exhibitionId}"){
                  companyUsers{
                    linkNameEn
                    company{
                      nameEn
                    }
                  }
                }
              }
              originName
              publisherType
              shareCount
              userCount
              viewCount
            }
          }
        }
      `;
      }
      else{
              return gql`
        query querySupplyDemand($query: QueryInput!) {
          querySupplyDemand(query: $query) {
            hasNextPage
            pageIndex
            totalCount
            items {
              createAt
              auditState
              commentCount
              type
              content
              exhibitionId
              followCount
              id
              imgUrls
              videos
              productName
              likeCount
              memberId
              publisher {
                avatarUrl
                compName
                publisherName
                publishId
                jobTitle
              }
              member{
                flagStyle
              }
              originName
              publisherType
              shareCount
              userCount
              viewCount
            }
          }
        }
      `;
      }
    },
  },
  created() {
    
    this.init();
  },
  methods: {
    ...mapActions({
      followerSupply: "follower/followerSupply",
      delFollowerSupply: "follower/delFollowerSupply",
      LinkToSupply: "linkTo/LinkToSupply",
      LinkHotSupply: "linkTo/LinkHotSupply",
      graphqlPost: "en/graphqlPostByZXS", //阿波罗接口方法
    }),

    init() {
      this.getSupplyList();
      console.log(this.userInfo,'ssss')
    },
    typeChange(){
      this.$Myapollo.addExhibitionView();
      this.pageIndex=1;
      this.dataList=[];
      this.getSupplyList();
    },
    toolHandle() {
      // 发布商机
      if (!this.userInfo) {
        this.$Myapollo.NoUserInfo(this);
        return;
      } else if(this.userInfo&&this.userInfo.inMember.isBlacklist){
        this.$toast.fail('You do not have access');
        return 
      }
      this.LinkHotSupply();
    },
    loadMore() {
      if (this.finished) return;
      this.pageIndex += 1;
      console.log(this.pageIndex, "当前加载的页面");
      this.getSupplyList();
    },
    getSupplyList() {
      let where = {
        Equal: {
          n: "auditState",
          v: 1,
        },
        Equal2: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
        "Equal_type":{
          "n":'type',
          "v":this.typeActive
        }
      };
      let order = [
        {
          n: "auditTime",
          v: 0,
        },
      ];
      this.$apollo.addSmartQuery("querySupplyDemand", {
        query: this.SupplyGql,
        variables: {
          query: {
            page: this.pageIndex,
            size: this.pageSize,
            where: JSON.stringify(where),
            order: JSON.stringify(order),
          },
        },
        fetchPolicy: "no-cache", // 清除缓存的数据，重新获取服务器数据
        result(res) {
          let data = JSON.parse(JSON.stringify(res));
          console.log(data, "供需");
          if (data && data.data.querySupplyDemand.items.length) {
            let currentList = data.data.querySupplyDemand.items;
            currentList.map((c) => {
              c.type=c.type.indexOf('Supply')!=-1?'Supply':'Purchase'
              if (c.imgUrls) {
                c.imgUrls = c.imgUrls.split(";");
              } else {
                c.imgUrls = [];
              }
              if(c.videos){
                  c.videos=JSON.parse(c.videos)
              }
              if(c.content){
                c.content=c.content.split("\n").join("<br>");
              }
            });
            if (this.pageIndex == 1) {
              this.dataList = currentList;
            } else {
              this.dataList = [...this.dataList, ...currentList];
            }
            this.$nextTick(() => {
              $("html , body").animate({ scrollTop: 1 }, 0, () => {
                $("html , body").stop().animate({ scrollTop: 0 }, 0);
              });
            });
            this.loading = false;
            if (!data.data.querySupplyDemand.hasNextPage) {
              this.finished = true;
            }
            console.log(this.dataList,'dataList')
          }
        },
        error(error) {
          console.error(error, "error错误处理");
        },
      });
    },
    //关注
    async likeClick(id) {
      if(this.isLoading){
        return 
      }
      if(!this.userInfo){
        this.$Myapollo.NoUserInfo(this);
        return
      }
      this.isLoading=true;
      let user = {
        name: this.userInfo.name,
        nickName: this.userInfo.nickName,
        avatarUrl: this.userInfo.avatarUrl,
        jobTitle: this.userInfo.jobTitle,
      };
      let opt = {
        supplyDemandId: id,
        memberId: this.userInfo.id,
        userInfo: JSON.stringify(user),
      };
      let res = await this.followerSupply(opt);
      this.isLoading=false;
      if (res.result) {
        this.$toast.success("已关注 ");
        if (id) {
          this.dataList.map((c) => {
            if (id === c.id) {
              c.isFollow = true;
            }
          });
        }
      } else {
        this.$toast.fail("关注失败 ");
      }
    },
    //取消关注
    async cancelLike(id) {
      let opt = {
        DemandId: id,
        memberId: this.userInfo.id,
      };
      let res = await this.delFollowerSupply(opt);
      if (res.result) {
        this.$toast.success("取消关注 ");
        if (id) {
          this.dataList.map((c) => {
            if (id === c.id) {
              c.isFollow = false;
            }
          });
        }
      } else {
        this.$toast.fail("取消失败 ");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.et {
  position: fixed;
  z-index: 12;
  bottom: 2.18rem;
  right: 0.2rem;
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  width: 1.26rem;
  justify-content: center;

  .item {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    text-align: center;
    align-items: center;
    justify-content: center;
    margin-top: 0.15rem;
    position: relative;
    background-color: #ff5c00;
    &.item_gx {
      box-shadow: 0 0.05rem 0.1rem 0 rgba(255, 92, 0, 0.4);
      color: #fff;
      display: flex;
      align-items: center;
      font-size: 0.24rem;
      justify-content: center;
    }
    &.item_topic {
      box-shadow: 0 0.05rem 0.1rem 0 rgba(1, 44, 126, 0.4);
    }
    .icon {
      width: 1rem;
      height: 1rem;
    }
    &.item_gx {
      width: 1rem;
      height: 1rem;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
  .item3 {
    width: 1rem;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .item2 {
    width: 1.26rem;
    height: 1.26rem;
    border-radius: 50%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;
    color: #ff416c;
    padding-top: 0.1rem;
    margin-top: 0.3rem;
    position: relative;

    img {
      display: block;
      width: 1.26rem;
      height: 1.26rem;
      border: 0.04rem solid #fff;
      border-radius: 50%;
    }
    &-txt {
      font-size: 0.2rem;
      position: absolute;
      width: 0.92rem;
      height: 0.38rem;
      line-height: 0.38rem;
      background-color: #fff;
      box-shadow: 0px 0.03rem 0.07rem 0px rgba(0, 0, 0, 0.2);
      border-radius: 0.18rem;
      border: solid 0.02rem #ff4b1b;
      bottom: -0.19rem;
    }
    &.s-red {
      background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
        linear-gradient(#fff, #fff);
      color: #fff;
    }
  }
}
.topic_supply {
  padding: 1.2rem 0.3rem 0;
  .typeNav{
    background: #f5f5f5;
    width: 100%;
    height: 45px;
    position: fixed;
    top: calc(0.93rem + 0.9rem);
    left: 0;
    z-index: 9;
    ::v-deep{
      .van-tabs{
        width: 100%;
        .van-tabs__wrap{
          height: 45px;
          width: 100%;
          padding: 0 0.3rem 5px;
          background: #f5f5f5;
          .van-tabs__nav {
            background:  #f5f5f5;
            padding-bottom: 10px;
            //  height:54px;
            .van-tab--active{
              .van-tab__text{
                background: transparent;
                color: #1890ff;
              }
            }
            .van-tabs__line{
              display: block;
              background-color: #1890ff;
              width: 0.5rem!important;
            }
          }
          
        }
      }
    }
  }
  .supply_list {
    .supplu_item {
      background-color: #fff;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      padding: 0.2rem;
      margin-bottom: 0.3rem;
      box-sizing: border-box;
      &:last-child {
        margin-bottom: 0;
      }
      .item_info {
        margin-bottom: 0.2rem;
        display: flex;
        img {
          flex-shrink: 0;
          display: block;
          width: 0.7rem;
          height: 0.7rem;
          box-sizing: border-box;
          border: 1px solid #e6e6e6;
          border-radius: 50%;
          // object-fit: cover;
          margin-right: 0.15rem;
        }
        .top_info {
          width: calc(100% - 1.95rem);
          color: #666;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          &.no_job {
            justify-content: center;
          }
          .info1 {
            display: flex;
            align-items: flex-end;
            .name {
              font-size: 0.26rem;
              margin-right: 0.1rem;
              font-weight: bold;
              color: #333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .job {
              flex-shrink: 0;
              font-size: 0.2rem;
              transform: translateY(-0.02rem);
              color: #666;
            }
          }
          .comp_name {
            color: #666;
            font-size: 0.2rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .right_info {
          flex-shrink: 0;
          margin-left: auto;
          display: flex;
          align-items: center;
          .like_btn {
            height: 0.48rem;
            width: 1.1rem;
            border-radius: 0.26rem;
            background: #ff5c00;
            color: #fff;
            font-size: 0.24rem;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            &.cancel_btn {
              border: solid 1px #ff5c00;
              color: #ff5c00;
              background: transparent;
            }
          }
        }
      }
      .item_top {
        font-size: 0.26rem;
        // font-weight: bold;
        color: #333;
        line-height: 0.4rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        span {
          color: #1890ff;
          margin-right: 5px;
        }
      }
      .item_img{
        display: flex;
        margin-top: 0.2rem;
        &.video{
          position: relative;
          width: 1.1rem;
          height: 1.1rem;
          img{
            margin-right: 0;
          }
          .play_mask{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba($color: #000, $alpha: 0.2);
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont{
              font-size: 0.64rem;
              color: #fff;
            }
          }
        }
        img{
          width: 1.1rem;
          height: 1.1rem;
          margin-right: 0.1rem;
          &:last-child{
            margin-right: 0;
          }
        }
      }
      .item_bottom {
        margin-top: 0.2rem;
        padding-top: 0.2rem;
        border-top: 1px dashed #e5e5e5;
        display: flex;
        justify-content: space-between;
        color: #666;
        font-size: 0.22rem;
        .item_count {
          display: flex;
          align-items: center;
          span {
            margin-right: 0.2rem;
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
.f-tac {
  text-align: center;
  color: #969799;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
